import React from 'react';

interface StarIconProps {
  filled?: boolean;
  size?: number;
  className?: string;
  useSvg?: boolean;
}

const StarIcon: React.FC<StarIconProps> = ({ filled = true, size = 24, className = '', useSvg = false }) => {
  if (useSvg) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={filled ? '#FFD700' : 'none'}
        stroke={filled ? 'none' : '#D1D5DB'}
        strokeWidth={filled ? 0 : 2}
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={{
          filter: filled ? 'drop-shadow(0 0px 4px rgba(255, 215, 0, 0.1))' : 'none'
        }}
      >
        <use href="/star.svg#star-path" />
      </svg>
    );
  }

  return (
    <div
      className={`star-icon ${filled ? 'filled' : 'empty'} ${className}`}
      role="img"
      aria-label="star"
      style={{
        width: size,
        height: size,
        filter: filled ? 'drop-shadow(0 0px 4px rgba(255, 215, 0, 0.1))' : 'none',
      }}
    />
  );
};

export default StarIcon;
